import { api } from 'services';

const BUService = {
  getAll: async () => {
    return await api.get('bu');
  }
};

export default BUService;
